import { createStore } from 'zustand/vanilla';

export const secondStore = createStore<{ seconds: number }>(() => ({
  seconds: 0,
}));
